// import checkoutApi from './dev';  // dev
import checkoutApi from './prod'; // prod

export default checkoutApi;
